export const OWNERSHIP_SEARCH_MIN_LENGTH = 1;
export const OWNERSHIP_SEARCH_DEBOUNCE_TIME = 0;

export interface OwnershipToolbarAction {
    key: string;
    label: string;
    onClick: () => void;
}

export function getOwnershipToolbarActions({
    hasConsolidationGroups,
    onAddConsolidationGroup,
    onAddEntity,
}: {
    hasConsolidationGroups: boolean;
    onAddConsolidationGroup: () => void;
    onAddEntity: () => void;
}): OwnershipToolbarAction[] {
    return [
        ...(!hasConsolidationGroups
            ? [
                  {
                      key: "consolidate",
                      label: "Consolidate",
                      onClick: onAddConsolidationGroup,
                  },
              ]
            : []),
        {
            key: "add-entity",
            label: "Add entity",
            onClick: onAddEntity,
        },
    ];
}
